import SubtitleTrack from '@/webgl/audio/SubtitleTrack'
import ILoadable from '@/webgl/runner/interfaces/ILoadable'

export default class SubtitleFile implements ILoadable {
  public constructor(readonly url: string) {}

  async load(abort: AbortSignal): Promise<SubtitleTrack> {
    const response = await fetch(this.url, { signal: abort })
    if (!response.ok) {
      console.error(`Failed to load the SRT file : ${this.url}.`)
      return
    }

    const track = new SubtitleTrack()
    const srtContent = await response.text()
    if (abort.aborted) return null

    track.parseSRT(srtContent)
    return track
  }
}
